'use strict'

KEY_ENTER = 13
KEY_ARROW_UP = 38
KEY_ARROW_DOWN = 40

templates =
  main: require '../main.html.mustache'
  autocomplete: require '../autocomplete.html.mustache'

module.exports = class AddressInput

  constructor: ({ @el, @onSubmit, @onFocus, @placeholder }) ->
    @rootUrl = '/merchant-page/address-input'
    @$el = $ @el

    @render()

    @$input = @$el.find '.mpp-address-input'
    @$autocomplete = @$el.find '.autocomplete-suggestions'

    @cache =
      autocomplete: {}
      addressDetails: {}

    @keyupDebounceTimeout = null

    # This is to keep track of when the ajax call was made so that if the responses arrive
    # in different order we don't replace a newer result with an older one.
    @lastAjaxRequestSent = 0
    @lastAjaxResponseReceived = 0

    @bindings()

  value: ->
    @$input.val().trim()

  clear: ->
    @$input.val ''

  render: ->
    templateData =
      placeholder: @placeholder

    templateData.translate = templateData.t = -> (text) -> I18n.translate text

    html = templates.main.render templateData
    @$el.html html

  bindings: ->
    previousText = null
    @$input.keyup (evt) =>
      return if evt.which in [KEY_ENTER, KEY_ARROW_UP, KEY_ARROW_DOWN]
      clearTimeout(@keyupDebounceTimeout) if @keyupDebounceTimeout?
      @keyupDebounceTimeout = setTimeout (=>
        currentText = @value()
        return if previousText is currentText
        previousText = currentText
        @inputChanged()
      ), 150

    @$input.focus (evt) => @onFocus?()

    @$input.keydown (evt) =>
      switch evt.which
        when KEY_ARROW_DOWN then @moveSelectionDown()
        when KEY_ARROW_UP then @moveSelectionUp()
        when KEY_ENTER
          @hideAutoComplete()
          @onSubmit?()

    @$input.blur =>
      # this timeout is necessary so that the click handler on .suggestion is triggered
      setTimeout (=> @hideAutoComplete()), 250

    @$el.on 'click', '.suggestion', (evt) =>
      @chooseSuggestion $(evt.currentTarget)

  highlightSelectedSuggestion: (rowNumber) ->
    $suggestions = @$autocomplete.find '.suggestion'
    return unless $suggestions?[rowNumber]?

    $suggestions.removeClass 'selected'
    $selected = $($suggestions[rowNumber])
    $selected.addClass 'selected'

    text = $selected.data 'address'
    @$input.val text

  # step should be a positive or negative number
  getNextHighlightedSuggestionNumber: (step) ->
    $suggestions = @$autocomplete.find '.suggestion'
    return null unless $suggestions.length > 0

    for i in [0..$suggestions.length]
      if $($suggestions[i]).hasClass 'selected'
        selected = i
        break

    if not selected?
      if step > 0
        selected = -1
      else
        selected = 0

    number = ((selected + step) % $suggestions.length)
    number = $suggestions.length + number if number < 0
    number

  moveSelectionDown: ->
    number = @getNextHighlightedSuggestionNumber 1
    @highlightSelectedSuggestion number

  moveSelectionUp: ->
    number = @getNextHighlightedSuggestionNumber -1
    @highlightSelectedSuggestion number

  chooseSelected: ->
    $suggestion = @$autocomplete.find '.suggestion.selected'
    @chooseSuggestion $suggestion

  chooseSuggestion: (element) ->
    text = $(element).data 'address'
    @$input.val text
    @hideAutoComplete()

    # We call getAddressDetails() here so that we already have the cached value
    # when we call this function again after the user clicks "Start Order".
    @getAddressDetails()

  inputChanged: ->
    input = @value()
    return @hideAutoComplete() unless input.length >= 3

    if @cache.autocomplete[input]?
      return @updateAutocomplete @cache.autocomplete[input]

    @lastAjaxRequestSent += 1
    ajaxCallNumber = @lastAjaxRequestSent

    $.ajax
      url: "#{@rootUrl}/autocomplete"
      type: 'GET'
      contentType: 'application/json'
      dataType: 'json'
      data: { input }
      success: (res) =>
        @cache.autocomplete[input] = res.data unless res?.result isnt 'ok'

        return unless ajaxCallNumber > @lastAjaxResponseReceived
        @lastAjaxResponseReceived = ajaxCallNumber

        return @hideAutoComplete() unless res?.result is 'ok'
        @updateAutocomplete res.data
      error: =>
        @hideAutoComplete()

  hideAutoComplete: ->
    clearTimeout(@keyupDebounceTimeout) if @keyupDebounceTimeout?
    @$autocomplete.hide()
    @$autocomplete.empty()

  updateAutocomplete: ({ addresses }) ->
    return @hideAutoComplete() unless addresses.length > 0

    suggestions = []

    for address in addresses
      # Given that in the context of GDT the user should only expect to see addresses in their own country,
      # we simplify the options shown by removing the country from the autocomplete suggestions.
      # If we ever use this autocomplete in other countries, we could add more countries to this regex.
      suggestions.push
        fullAddress: address.description
        shortAddress: address.description?.replace /, United States$/, ''

    templateData = { suggestions }
    templateData.translate = templateData.t = -> (text) -> I18n.translate text

    html = templates.autocomplete.render templateData
    @$autocomplete.html html
    @$autocomplete.show()

  getAddressDetails: (cb = ->) ->
    input = @value()
    return cb(null, @cache.addressDetails[input]) if @cache.addressDetails[input]?

    $.ajax
      url: "#{@rootUrl}/address-details"
      type: 'GET'
      contentType: 'application/json'
      dataType: 'json'
      data: { input }
      success: (res) =>
        return cb(new Error("Error Code: #{res?.error?.code}")) unless res?.result is 'ok'
        @cache.addressDetails[input] = res.data
        return cb null, res.data
      error: ->
        return cb(new Error('Request Failed'))
